import { Component, ChangeDetectionStrategy } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
	selector: "stages-files-main",
	templateUrl: "./main.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [RouterOutlet],
})
export class MainComponent {}
